<ngx-spinner bdColor="rgba(151,149,149,0.4)" size="large" color="orange" type="ball-clip-rotate-pulse"
  fullScreen="true">
  <p style="font-size: 20px; color: black">Booking Order...</p>
</ngx-spinner>

<div class="section" *ngIf="cartData.total > 0">
  <!-- container -->
  <div class="container">
    <!-- row -->
    <div class="row">

    
      <div class="col-md-7">
        <!-- Billing Details -->
        <div class="billing-details">
          <div class="section-title">
            <h3 class="title">Billing address</h3>
          </div>
         <form [formGroup]="checkoutForm" (ngSubmit)="onCheckout()">
            <div class="form-group">
              <input class="input" type="text" formControlName="fname" placeholder="First Name">
            </div>
            <div class="form-group">
              <input class="input" type="text" formControlName="lname" placeholder="Last Name">
            </div>
            <div class="form-group">
              <input class="input" type="email" formControlName="email" placeholder="Email">
              <div *ngIf="checkoutForm.get('email')?.invalid && checkoutForm.get('email')?.touched" class="text-danger">
      Please enter a valid email
    </div>
            </div>
            <div class="form-group">
              <input class="input" type="text" formControlName="address" placeholder="Address">
            </div>
            <div class="form-group">
              <input class="input" type="text" formControlName="city" placeholder="City">
            </div>
            <div class="form-group">
              <input class="input" type="text" formControlName="country" placeholder="Country">
            </div>
            <div class="form-group">
              <input class="input" type="tel" formControlName="tel" placeholder="Telephone">
            </div>
            <div class="form-group">
              <div class="input-checkbox">
                <input type="checkbox" id="create-account">
                <label for="create-account">
                  <span></span>
                  Create Account?
                </label>
                <div class="caption">
                  <input class="input" type="password" name="password" placeholder="Enter Your Password">
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- /Billing Details -->

        <!-- Shiping Details -->
        <div class="shiping-details">
          <div class="section-title">
            <h3 class="title">Shiping address</h3>
          </div>
          <div class="input-checkbox">
            <input type="checkbox" id="shiping-address">
            <label for="shiping-address">
              <span></span>
              Ship to a diffrent address?
            </label>
            <div class="caption">
              <form>
              <div class="form-group">
                <input class="input" type="text" name="first-name" placeholder="First Name">
              </div>
              <div class="form-group">
                <input class="input" type="text" name="last-name" placeholder="Last Name">
              </div>
              <div class="form-group">
                <input class="input" type="email" name="email" placeholder="Email">
              </div>
              <div class="form-group">
                <input class="input" type="text" name="address" placeholder="Address">
              </div>
              <div class="form-group">
                <input class="input" type="text" name="city" placeholder="City">
              </div>
              <div class="form-group">
                <input class="input" type="text" name="country" placeholder="Country">
              </div>
              <div class="form-group">
                <input class="input" type="tel" name="tel" placeholder="Telephone">
              </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Shiping Details -->

        <!-- Order notes -->
        <div class="order-notes">
          <textarea class="input" placeholder="Order Notes"></textarea>
        </div>
        <!-- /Order notes -->
      </div>
    

  
      <!-- Order Details -->
      <div class="col-md-5 order-details">
        <div class="section-title text-center">
          <h3 class="title">Your Order</h3>
        </div>
        <div class="order-summary">
          <div class="order-col">
            <div><strong>PRODUCT</strong></div>
            <div><strong>SubTotal</strong></div>
          </div>
          <div class="order-products">
            <div class="order-col" *ngFor="let c of cartData.data;">
              <div>{{c.numInCart}}x {{c.product.name}}</div>
              <div>{{(c.product.price*c.numInCart) | currency:'INR'}}</div>
            </div>
          </div>
          <div class="order-col">
            <div>Shipping</div>
            <div><strong>FREE</strong></div>
          </div>
          <div class="order-col dropdown-divider">
            <div><strong>TOTAL</strong></div>
            <div><strong class="order-total">{{cartTotal | currency:'INR'}}</strong></div>
          </div>
        </div>
        <form>
        <div class="payment-method">
          <div class="input-radio">
            <input type="radio" name="payment" id="payment-1">
            <label for="payment-1">
              <span></span>
              Direct Bank Transfer
            </label>
          </div>
          <div class="input-radio">
            <input type="radio" name="payment" id="payment-2">
            <label for="payment-2">
              <span></span>
              Cheque Payment
            </label>
          </div>
          <div class="input-radio">
            <input type="radio" name="payment" id="payment-3">
            <label for="payment-3">
              <span></span>
              Paypal System
            </label>
          </div>
        </div>
        <div class="input-checkbox">
          <input type="checkbox" id="terms">
          <label for="terms">
            <span></span>
            I've read and accept the <a href="#">terms & conditions</a>
          </label>
        </div>
        <button type="submit" class="btn-outline-danger btn-sm my-2 btn-block" [disabled]="cartTotal <= 0 "
          (click)=onCheckout()>
          Place order
        </button>
         </form>
      </div>
     
      <!-- /Order Details -->
    </div>
    <!-- /row -->
  </div>
  <!-- /container -->
</div>
<!-- /SECTION -->

<div class="text-center my-5" *ngIf="cartData.total <= 0">
  <h4>Your Cart Is Empty</h4>
  <button class="btn btn-primary btn-lg mt-3" routerLink="/">GO TO SHOP</button>
</div>